/*
* Palo Alto Theme
*
* Use this file to add gift Javascript to Palo Alto.  Keeping your gift
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the gift.js script import line near the bottom of the file.
*/
document.addEventListener("DOMContentLoaded", function(){
        if (jQuery(".testimonials__wrapper .testimonial__item .testimonial__text p").length) {
            jQuery(".testimonials__wrapper .testimonial__item .testimonial__text p").matchHeight();
        }
        if (jQuery(".collection-gift-boxes .product-grid-item .product-grid-item__title").length) {
            jQuery(".collection-gift-boxes .product-grid-item .product-grid-item__title").matchHeight();
        }
        if (jQuery("h3.list-collections__item__title").length) {
            jQuery("h3.list-collections__item__title").matchHeight();
        }
        if (jQuery(".product-grid-item .product-grid-item__info a.product-grid-item__rating").length) {
            jQuery(".product-grid-item .product-grid-item__info a.product-grid-item__rating").matchHeight();
        }
      
});

